import React, { useState, useEffect } from "react";
// Chakra imports
import {
  HStack,
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon,
  Grid,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { FaCheck, FaTimes } from "react-icons/fa";
// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import TablesProjectRow from "components/Tables/TablesProjectRow";
import TablesTableRow from "components/Tables/TablesTableRow";

import useGetProductsArchives from "../../hooks/useGetProductsArchives";
import Pagination from "views/Custom/Pagination";
import ApproveArchive from "modals/ApproveArchive";
import DeclineArchive from "modals/DeclineArchive";

function ProductArchives() {
  
  const textColor = useColorModeValue("gray.700", "white");

  const [ status, setStatus ] = useState('Pending');
  const [ page, setPage ] = useState(1); 
  const pageLimit = 10;
  let { 
    productsArchives, 
    totalProductsArchives, 
    setGettingProductsArchives, 
    gettingProductsArchives, 
    gettingProductsArchivesReqSuccess 
  } = useGetProductsArchives({ 
    page, 
    limit: pageLimit,
    status, 
  });

  const [ toApproveArchive, setToApproveArchive ] = useState(null);
  const { isOpen: isOpenApprove, onOpen: onOpenApprove, onClose: onCloseApprove } = useDisclosure();

  const [ toDeclineArchive, setToDeclineArchive ] = useState(null);
  const { isOpen: isOpenDecline, onOpen: onOpenDecline, onClose: onCloseDecline } = useDisclosure();


  useEffect(() => {
    reloadPage();
  }, [page]);


  useEffect(() => {
    if (parseInt(page) != 1) {
      setPage(10);
    } else {
      reloadPage();
    }
  }, [status]);


  const reloadPage = () => {
    setGettingProductsArchives(true);
  }

  // React.useEffect(() => {
  //   console.log(productsArchives);
  // }, [productsArchives]);


  return (
    <>
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>

      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader p="6px 0px 22px 0px">
          <Flex w="100%"
            flexDirection={{
              sm: "row",
              md: "row",
            }}
            alignItems={{ xl: "center" }}>

            <HStack>
              <Select 
                defaultValue={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option key="status-Pending" value="Pending">Pending</option>
                <option key="status-Approved" value="Approved">Approved</option>
                <option key="status-Declined" value="Declined">Declined</option>
                <option key="status-All" value="All">All</option>
              </Select>
            </HStack>
          </Flex>
        </CardHeader>
        <CardBody>
          <Flex direction="column" w="100%">
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" p={2} color="gray.400">
                  <Th p={2} color="gray.400">Requested By</Th>
                  <Th p={2} color="gray.400">Comment</Th>
                  <Th p={2} color="gray.400">Requested Time</Th>
                  <Th p={2} color="gray.400">Name (Description)</Th>
                  <Th p={2} color="gray.400">Vehicle</Th>
                  <Th p={2} color="gray.400">Approved Time</Th>
                  <Th p={2} color="gray.400">Declined Time</Th>
                  <Th p={2} color="gray.400">Actions</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {gettingProductsArchives ?
                  <Tr my=".8rem" >
                    <Td minWidth={{ sm: "250px" }} p={2} colSpan={6}>
                      <Progress isIndeterminate />
                    </Td>
                  </Tr>
                  : productsArchives.map((pa) => {
                    return (
                      <Tr my=".8rem" key={`prod-item-${pa.id}`}>
                        <Td  p={2}>{pa.requestor
                          ? `${pa.requestor.firstName} ${pa.requestor.lastName}`
                          : null
                        }</Td>
                        <Td  p={2}>{pa.requestedComment}</Td>
                        <Td  p={2}>{new Date(pa.requestedAt).toLocaleString()}</Td>
                        <Td  p={2}>{pa.product.name} ({pa.product.description})</Td>
                        <Td  p={2} fontSize="sm">
                          {pa.product.carMake ? pa.product.carMake : ''} {pa.product.carType ? ` ${pa.product.carType}` : ''} 
                          {pa.product.carYear ? ` (${pa.product.carYear})` : ''} <br/>
                          {pa.product.carPart ? `Part No: ${pa.product.carPart}` : ''} 
                        </Td>
                        <Td  p={2}>{pa.approvedAt
                          ? new Date(pa.approvedAt).toLocaleString()
                          : null
                        }</Td>
                        <Td  p={2}>{pa.declinedAt
                          ? new Date(pa.declinedAt).toLocaleString()
                          : null
                        }</Td>
                        <Td  p={2}>
                          <Flex flexDirection="row">

                            { pa.approvedAt || pa.declinedAt
                              ? null
                              : <Button p="0px" 
                              bg="transparent" 
                              onClick={() => {
                                setToApproveArchive(pa);
                                onOpenApprove(true);
                              }}>
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaCheck} me="4px" />
                                <Text fontSize="xs" fontWeight="semibold">
                                  APPROVE
                                </Text>
                              </Flex>
                            </Button>
                            }
                            


                            { pa.approvedAt || pa.declinedAt
                              ? null
                              : <Button p="0px" 
                              bg="transparent" 
                              onClick={() => {
                                setToDeclineArchive(pa);
                                onOpenDecline(true);
                              }}>
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaTimes} me="4px" />
                                <Text fontSize="xs" fontWeight="semibold">
                                  DECLINE
                                </Text>
                              </Flex>
                            </Button>
                            }

                          </Flex>
                        </Td>
                      </Tr>
                    );
                  })
                }
              </Tbody>
            </Table>
            <Pagination 
              totalItems={totalProductsArchives}
              pageRows={pageLimit}
              currentPage={page}
              onPageChanged={setPage}
            />
          </Flex>
        </CardBody>
      </Card>

    </Flex>
    
    {/* <CreateProduct 
      isOpen={isOpenCreate}
      onClose={onCloseCreate}
      successCallback={reloadPage}
    />*/}
           
    <ApproveArchive 
      isOpen={isOpenApprove}
      onClose={() => {
        setToApproveArchive(null);
        onCloseApprove();
      }}
      successCallback={reloadPage}
      archiveData={toApproveArchive}
    /> 

    <DeclineArchive 
      isOpen={isOpenDecline}
      onClose={() => {
        setToDeclineArchive(null);
        onCloseDecline();
      }}
      successCallback={reloadPage}
      archiveData={toDeclineArchive}
    /> 

    </>
  );
}

export default ProductArchives;
